<div class="container-filter__padding">
    <div class="item-filter">
      <div class="lista">
        <span class="filtrar-por-ramo">Filtrar por ramo</span>
        <div style="margin-top: 5px"></div>
        @for(item of _RAMOS; track item) {
        <div class="item">
          <mat-checkbox
            class="filter-radio-margin"
            disableRipple
            color="primary"
            labelPosition="before"
            [ngModel]="filtrarRamos.includes(item.ramo)"
            (ngModelChange)="updateFiltroRamo(item.ramo)"
          >
            <div style="position: absolute; width: 90%; height: 50%; cursor: pointer;"></div>
            <span
              class="filter-text"
              style="cursor: pointer; white-space: nowrap"
              >{{ item.label }}</span
            >
          </mat-checkbox>
        </div>
        }
      </div>
    </div>
</div>
